import React from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { Text } from '../../pulsechain_components/Text';
import { routesEnum } from '../../Routes';
import { WorkflowStep } from '../../store/actions/workflowActions';

interface StartOverLinkProps {
  dispatchClearDepositData: () => void;
  dispatchWorkflowUpdate: (step: WorkflowStep) => void;
  className?: string;
}

export const StartOverLink = ({
  dispatchClearDepositData,
  dispatchWorkflowUpdate,
  className = 'mt10',
}: StartOverLinkProps): JSX.Element => {
  const history = useHistory();
  const { formatMessage } = useIntl();

  const handleStartOver = () => {
    if (
      !window.confirm(
        formatMessage({
          defaultMessage:
            'Are you sure you want to start over? This will clear all deposit data and transaction history.',
        })
      )
    ) {
      return;
    }

    dispatchClearDepositData();
    dispatchWorkflowUpdate(WorkflowStep.OVERVIEW);
    history.push(routesEnum.landingPage);
  };

  return (
    <div className={`flex center ${className}`}>
      <Text
        size="small"
        color="blueMedium"
        style={{ cursor: 'pointer', textDecoration: 'underline' }}
        onClick={handleStartOver}
      >
        <FormattedMessage defaultMessage="Start over with new deposit data" />
      </Text>
    </div>
  );
};
